import { render } from "./VideoSettingsSection.vue.js?vue&type=template&id=3c0d0502!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoSettingsSection.vue?vue&type=template&id=3c0d0502"
import script from "./VideoSettingsSection.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoSettingsSection.vue?vue&type=script&lang=js"
export * from "./VideoSettingsSection.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/settings/VideoSettingsSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c0d0502"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c0d0502', __exports__)) {
    api.reload('3c0d0502', __exports__)
  }
  
  module.hot.accept("./VideoSettingsSection.vue.js?vue&type=template&id=3c0d0502!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoSettingsSection.vue?vue&type=template&id=3c0d0502", () => {
    api.rerender('3c0d0502', render)
  })

}


export default __exports__